import { createTracker } from 'usage-tracker-public';
import events from '../../events.yaml';
const tracker = createTracker({
  events,
  allowUnauthed: true,
  properties: {
    email: 'test@hubspot.com',
    hubId: null,
    lang: null
  }
});
export const loginVerificationWithHSAuthInitiated = userEmail => {
  tracker.setProperties({
    email: userEmail
  });
  tracker.track('loginVerificationWithHSAuthenticator', {
    action: 'Initiated',
    type: 'login-verification-hs-authenticator-initiated'
  });
};
export const loginVerificationWithHSAuthAccomplished = () => {
  tracker.track('loginVerificationWithHSAuthenticator', {
    action: 'Accomplished',
    type: 'login-verification-hs-authenticator-succeded'
  });
};
export const loginVerificationWithHSAuthFailed = () => {
  tracker.track('loginVerificationWithHSAuthenticator', {
    action: 'Failed',
    type: 'login-verification-hs-authenticator-failed'
  });
};
export const loginVerificationWithHSAuthResend = () => {
  tracker.track('loginVerificationWithHSAuthResent', {
    action: 'Resend',
    type: 'login-verification-hs-authenticator-resent'
  });
};
export const loginVerificationWithHSAuthCodeInitiated = () => {
  tracker.track('loginVerificationWithHSAuthCode', {
    action: 'Initiated',
    type: 'login-verification-hs-authenticator-code-initiated'
  });
};
export const loginVerificationWithHSAuthCodeAccomplished = () => {
  tracker.track('loginVerificationWithHSAuthCode', {
    action: 'Accomplished',
    type: 'login-verification-hs-authenticator-code-succeded'
  });
};
export const loginVerificationWithHSAuthCodeOpened = () => {
  tracker.track('loginVerificationWithHSAuthCodeOpen', {
    action: 'Opened',
    type: 'login-verification-hs-authenticator-code-open'
  });
};
export const trackRememberThisDevice = () => {
  tracker.track('remeberDevice', {
    action: 'Initiated',
    type: 'login-and-remeber-device'
  });
};
export const trackDoNotRememberThisDevice = () => {
  tracker.track('doNotRemeberDevice', {
    action: 'Initiated',
    type: 'login-and-do-not-remeber-device'
  });
};
export const trackLoginWith2faHSAuthAccomplished = () => {
  tracker.track('loginWith2FAHSAuth', {
    action: 'Accomplished',
    type: 'login-with-2fa-HSAuth-succeded'
  });
};
export const trackLoginWith2faHSAuthFailed = () => {
  tracker.track('loginWith2FAHSAuth', {
    action: 'Failed',
    type: 'login-with-2fa-HSAuth-failed'
  });
};
export const trackSmartLoginLoad = userEmail => {
  tracker.setProperties({
    email: userEmail
  });
  tracker.track('smartLoginPageOpened');
};
export const trackSmartLoginOptOut = userEmail => {
  tracker.setProperties({
    email: userEmail
  });
  tracker.track('smartLoginOptOut');
};
export const trackTwoFactorRecoveryMobileAuth = reason => {
  tracker.track('twoFactorRecoveryMobileAuth', {
    action: 'Initiated',
    type: `hs-authenticator-recovery-${reason}`
  });
};